import type { PaymentStatus } from '@repo/api-contracts';

/** 고객 화면의 결제 상태 이름 — 토스 결제 상태(PAYMENT_STATUSES)를 그대로 옮긴다. */
export const PAYMENT_STATUS_LABELS: Readonly<Record<PaymentStatus, string>> = {
  READY: '결제 대기',
  DONE: '결제 완료',
  PARTIAL_CANCELED: '부분 취소',
  CANCELED: '결제 취소',
  ABORTED: '결제 실패',
  EXPIRED: '결제 만료',
};
